module.exports = __webpack_public_path__ + "static/media/data-slider-image-3.43e8a632.png";